import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import myAxios from '../../../../lib/axios';

const initialState = {
    data: [],
};

export const fetchIndustries = createAsyncThunk(
    'masters/fetchIndustries',
    async (query) => {
        try {
            const response = await myAxios.get(`/masters/industry`);
            return { success: true, message: "Industries fetched successfully!", data: response?.data?.industries };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);


export const createIndustries= createAsyncThunk(
    'masters/createIndustries',
    async (formData) => {
        try {
            const response = await myAxios.post(`/masters/industry`,  formData);

            return { success: true, message: "Industry added successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const updateIndustries= createAsyncThunk(
    'masters/updateIndustries',
    async (formData) => {
        try {
            const response = await myAxios.put(`/masters/industry/${formData.industryId}`, formData);

            return { success: true, message: "Industry updated successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const deleteIndustries= createAsyncThunk(
    'masters/deleteIndustries',
    async (query) => {
        try {
            const response = await myAxios.delete(`/masters/industry/${query.industryId}`);

            return { success: true, message: "Industry deleted successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);


const industriesSlice = createSlice({
    name: 'industries',
    initialState,
    reducers: {
        clearIndustriesData: state => {
            state.data = [];
        },
        setIndustriesData: (state, action) => {
            state.data = action.payload;
        },
       
    },
});

export const industriesReducer = industriesSlice.reducer;
export const { clearIndustriesData, setIndustriesData } = industriesSlice.actions;

export const selectIndustriesData = (state) => state.industries.data;
